import { createRangeTagManager } from '../../utils/createRangeTagManager';

export const kitchenAreaTagManager = createRangeTagManager({
  jsonQueryKey: 'kitchen',
  template: 'Площадь %s м²',
  id: 'kitchenArea',
});
